import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit encryption'
    },
    {
      icon: 'Lock',
      label: 'FERPA Compliant',
      description: 'Meets educational privacy standards'
    },
    {
      icon: 'CheckCircle',
      label: 'Secure Authentication',
      description: 'Multi-factor authentication available'
    }
  ];

  return (
    <div className="mt-8 lg:mt-12 pt-6 lg:pt-8 border-t border-border">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {badges?.map((badge, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-4 bg-success/5 rounded-lg border border-success/10"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name={badge?.icon} size={20} className="text-success" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground mb-1">
                {badge?.label}
              </h4>
              <p className="text-xs text-muted-foreground line-clamp-2">
                {badge?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;